"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFeatureWrapper = exports.PackageContents = exports.InfoIconWrapper = void 0;
var _react = require("@linaria/react");
var _intents = _interopRequireDefault(require("@ux/intents"));
var _core = require("@linaria/core");
"p1oxxwnd";
const intents = new _intents.default();
const PackageContents = exports.PackageContents = /*#__PURE__*/(0, _react.styled)("div")({
  name: "PackageContents",
  class: "p1d6aiuk"
});
const InfoIconWrapper = exports.InfoIconWrapper = /*#__PURE__*/(0, _react.styled)("span")({
  name: "InfoIconWrapper",
  class: "iusjqrx"
});
const StyledFeatureWrapper = exports.StyledFeatureWrapper = /*#__PURE__*/(0, _react.styled)("div")({
  name: "StyledFeatureWrapper",
  class: "stth0cz"
});